import { type TTafFetch, timeOutSeconds } from "../_tafFetch";
import { tafMiddlewareManager, ITafContext } from "./helper";
import { initMiddlewareManager } from "./use";

export function withMiddleware(tafFetch: TTafFetch): TTafFetch {
  initMiddlewareManager();
  return (params: Parameters<TTafFetch>[0]) => {
    const ctx: ITafContext = {
      request: {
        ...params,
        timeoutMS: params.timeoutMS ?? timeOutSeconds * 1000,
      },
      response: {},
      state: {},
    };
    const composedMiddleware = tafMiddlewareManager.compose(ctx);
    const coreRequest = async () => tafFetch(ctx.request);
    return new Promise((resolve, reject) => {
      composedMiddleware(coreRequest)
        .then(() => {
          resolve(ctx.response.data);
        })
        .catch(error => {
          ctx.response.error = error;
          reject(error);
        });
    });
  };
}
